import { createContext } from "react";
import type { MediaSelectorAPI } from "./MediaSelector";

/**
 *
 */
export const MediaSelectorApi = createContext<MediaSelectorAPI>({} as MediaSelectorAPI);
